import React from "react";
import Input from "../common/Input";
import Select from "../common/Select";
import counties from "../../options/counties.json";

function AlabamaTFC({ data, handleChange, handleSave }) {
  console.log("Counties", counties);
  const Json = counties.map((county) => ({
    _id: `${county.name}|${county.state_abbreviation}|${county._id}`,
    name: county.name,
    state_name: county.state_name,
    state_abbreviation: county.state_abbreviation,
  }));
  console.log("Counties JSON", JSON.stringify(Json));
  return (
    <>
      <div className="row">
        <div className="col">
          <Input
            type="date"
            name="applicationDate"
            label="Application Date"
            onChange={handleChange}
            value={data.DynamicFields.results.applicationDate}
          />
        </div>
        <div className="col">
          <Select
            name="facilityLocation"
            label="Facility Location"
            onChange={handleChange}
            value={data.DynamicFields.results.facilityLocation}
            options={counties.filter(
              (county) => county.state_name === "Alabama"
            )}
          />
        </div>
        <div className="col"></div>
      </div>
      <div className="row">
        <div className="col">
          <Select
            name="contractNumber"
            label="Contract Number"
            onChange={handleChange}
            value={data.DynamicFields.results.contractNumber}
            options={[
              { name: "TFC: 3901", _id: "TFC: 3901" },
              { name: "TLP: 3617", _id: "TLP: 3617" },
              { name: "M&I: 3706", _id: "M&I: 3706" },
              { name: "ILP: 3662", _id: "ILP: 3662" },
            ]}
          />
        </div>
        <div className="col">
          <Input
            name="contractName"
            label="Contract Name"
            onChange={handleChange}
            value={data.DynamicFields.results.contractName || "SAFY"}
            disabled={true}
          />
        </div>
        <div className="col">
          <Select
            name="providerType"
            label="Provider Type"
            onChange={handleChange}
            value={data.DynamicFields.results.providerType}
            options={[
              { name: "TFC-Enhanced", _id: "TFC-Enhanced" },
              { name: "TFC", _id: "TFC" },
              { name: "TLP", _id: "TLP" },
              { name: "M&I", _id: "M&I" },
              { name: "ILP", _id: "ILP" },
              { name: "Stepdown", _id: "Stepdown" },
            ]}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Select
            name="countyOfOrigin"
            label="County of Origin"
            onChange={handleChange}
            value={data.DynamicFields.results.countyOfOrigin}
            options={counties.filter(
              (county) => county.state_name === "Alabama"
            )}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <Select
            name="reasonRejected"
            label="Reason Rejected"
            onChange={handleChange}
            value={data.DynamicFields.results.reasonRejected}
            options={[
              {
                name: "Child Danger to Self or Others",
                _id: "ChildDangerToSelfOthers",
              },
              {
                name: "Actively Homicidal, Suicidal, Psychotic",
                _id: "ActivelyHomicidaluicidalPsychotic",
              },
              {
                name: "Needs Higher Level of Service",
                _id: "NeedsHigherLevelOfService",
              },
              {
                name: "Severe Medical Problems",
                _id: "SevereMedicalProblems",
              },
              {
                name: "Fire Setting within last 6 months",
                _id: "FireSettingWithinLast6Months",
              },
              {
                name: "TFC No family/home provider willing to accept child",
                _id: "NoWillingToAccept",
              },
            ]}
          />
        </div>
      </div>
      <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
        Save Referral
      </button>
    </>
  );
}

export default AlabamaTFC;
